import { NotificationCloseTriggerV1 as NoticationCloseTrigger, } from './types';
export * from './types';
export class NotificationDisplayServiceImplV1 {
    constructor(consumerId, store) {
        this.consumerId = consumerId;
        this.store = store;
    }
    createNotification(type, id, content, options) {
        this.store.createNotification(this.consumerId, type, id, content, options);
    }
    closeNotification(id) {
        this.store.closeNotification(this.consumerId, id, NoticationCloseTrigger.OUTSIDE);
    }
    isOpen(id) {
        return this.store.isOpen(this.consumerId, id);
    }
    getNotifications(types) {
        return this.store.getNotifications(types);
    }
    announceIntegratorNavigation() {
        this.store.announceIntegratorNavigation();
    }
    subscribe(listener) {
        return this.store.subscribe(listener);
    }
}
//# sourceMappingURL=consumer.js.map